import { invariant } from 'utils/invariant'

export const LFS_URL = process.env.NEXT_PUBLIC_LFS_URL
invariant(LFS_URL, 'NEXT_PUBLIC_LFS_URL is required within @repo/web-utils/env')

export const NEXT_PUBLIC_ASSET_BUCKET_URL = process.env.NEXT_PUBLIC_ASSET_BUCKET_URL
invariant(
  NEXT_PUBLIC_ASSET_BUCKET_URL,
  'NEXT_PUBLIC_ASSET_BUCKET_URL is required within @repo/web-utils/env',
)
